$(function() {
  setTimeout(function() {
    $('.id--9 .overall-wrapper, .in-krok-1 .overall-wrapper, .in-krok-2 .overall-wrapper')
      .show()
      .css('opacity', 1)
  }, 500)
})

// cart
function moveCartHeader() {
  if ($(window).width() > 1200) {
    if ($('body').hasClass('id--9') && $('.cart-table tbody .name').length === 0) {
      $('<tr class="name"><td>Produkt</td><td></td><td>Dostupnost</td><td>Množství</td><td>Cena za kus</td><td>Celkem</td><td></td></tr>').prependTo('.cart-row .cart-content .cart-table tbody')
    }
  }

  if ($('body').hasClass('id--9')) {
    $('.next-step a.btn').html('Pokračovat v objednávce')

    $('a.installments').each(function() {
      var strong = $(this).find('strong') // Najde <strong> uvnitř <a>
      if (strong.length) {
        var strongHTML = strong[0].outerHTML // Uchová původní <strong>
        $(this).html(`Můžete mít i na splátky již od ${strongHTML}`)
      }
    })
  }

  // step1
  if ($('body').hasClass('in-krok-1')) {
    $('.next-step-forward span').html('Pokračovat v objednávce')
  }

  // step2
  if ($('body').hasClass('in-krok-2')) {
    $('.next-step-forward span').html('Pokračovat v objednávce')
  }

  if ($('body').hasClass('ordering-process')) {
    $('.cart-header').insertBefore('.row.cart-row')
  }
}

$(document).on('ShoptetCartUpdated ShoptetDOMCartContentLoaded ShoptetDOMPageContentLoaded', function() {
  moveCartHeader()
})

$(document).ready(function() {
  // Kontrola dárkového balení
  if ($('.id--16 .cart-items .cart-item-name:contains("Lamela 36 mm")').length > 0) {
    $('body').addClass('neDobirka')
  }

  if ($('.id--16 .cart-items .cart-item-name:contains("Lamela 53 mm")').length > 0) {
    $('body').addClass('neDobirka')
  }
})


// cart
// start
jQuery(function($) {
  const products = [{ sku: 'CART-01', price: 500 }, { sku: 'CART-02', price: 1000 }]
  const events = ['DOMContentLoaded', 'ShoptetCartUpdated', 'ShoptetContentLoaded', 'ShoptetDOMCartContentLoaded', 'ShoptetDOMContentLoaded', 'ShoptetDOMPageContentLoaded', 'ShoptetDOMPageMoreProductsLoaded']

  // 1) Funkce, která checkboxy _vytvoří_, pokud ještě nejsou
  function renderToggles() {
    if ($('#my-product-toggles').length) return // už existují

    const labels = products.map(p => `
      <label style="display: block; margin-bottom: 8px;">
        <input type="checkbox" class="toggle-cart-product" data-code="${p.sku}">
        Chci odvézt starou matraci… <span class="green">+${p.price} Kč</span>
        <span class="sub">Vaši starou matraci odvezeme. Nemusíte se pak starat, kam s ní. Nechte to na nás.</span>
      </label>
    `).join('')

    // Vkládáme níže než .cart-summary.extras-wrapper, první child ve .id--9 main
    $(`<div id="my-product-toggles">${labels}</div>`)
      .insertAfter('.id--9 .cart-content table.cart-table')
  }

  // 2) Funkce, která nastaví checked podle skutečného stavu v košíku
  function syncToggles() {
    $('#my-product-toggles .toggle-cart-product').each(function() {
      const code = $(this).data('code')
      const inCart = !!$(`tr[data-micro-sku="${code}"]`).length
      $(this).prop('checked', inCart)
    })
  }

  // 3) Jediný change‑handler pro checkboxy
  $(document).on('change', '#my-product-toggles .toggle-cart-product', function() {
    const code = $(this).data('code')
    if (this.checked) {
      shoptet.cartShared.addToCart({ productCode: code })
    } else {
      const $row = $(`tr[data-micro-sku="${code}"]`)
      const $remove = $row.find('.remove-item span')
      if ($remove.length) {
        $remove.click()
      }
    }
  })

  // 4) Na všechny Shoptet eventy znovu vložíme (pokud chybí) a synchronizujeme
  $(document).on(events.join(' '), () => {
    renderToggles()
    syncToggles()
  })

  // 5) Spustíme jednou na start
  renderToggles()
  syncToggles()
})
// end


// cuponCart
// start
jQuery(function($) {
  const events = ['DOMContentLoaded', 'ShoptetCartUpdated', 'ShoptetContentLoaded', 'ShoptetDOMCartContentLoaded', 'ShoptetDOMContentLoaded', 'ShoptetDOMPageContentLoaded', 'ShoptetDOMPageMoreProductsLoaded']

  function renderCouponToggle() {
    if ($('#have-code').length) return
    $('.cart-table').after(`
      <div class="my-coupon">
        <label class="discount-code-toggle">
          <input type="checkbox" id="have-code">
          Mám slevový kód
        </label>
        <div class="cart-summary"></div>
      </div>
    `)

    $('#have-code').on('change', function() {
      $(this).closest('.my-coupon').toggleClass('open', this.checked)
    })

    $('.discount-coupon').appendTo('.my-coupon .cart-summary')
  }

  $(document).on(events.join(' '), function() {
    renderCouponToggle()
  })

  renderCouponToggle()
})
// end


// cartSurcharges
// start
function checkForMattressRemovalSurcharge() {
  var found = $('td.p-name').text().includes('Chci odvézt starou matraci')
  $('body').toggleClass('surcharges', found)
}

function initMattressWatcher() {
  checkForMattressRemovalSurcharge()

  // Změny z Shoptetu
  $(document).on('ShoptetCartUpdated ShoptetDOMCartContentLoaded', function() {
    checkForMattressRemovalSurcharge()
  })

  // Kliknutí na "Odstranit z košíku"
  $(document).on('click', '.remove-item', function() {
    // Po kliknutí necháme proběhnout odstranění a pak zkontrolujeme znovu
    setTimeout(checkForMattressRemovalSurcharge, 300)
  })
}

$(function() {
  initMattressWatcher()
})

// end
